import type {
  ContractRefundCommissionStatus,
  ContractRefundStatus,
} from '@/features/contracts/types/contract.types';
import { formatPrice } from '@/features/contracts/utils/contractFormatter';

/** Montant en centimes → « 89,00 € ». */
export const formatCents = (cents: number | null | undefined): string =>
  cents === null || cents === undefined ? '-' : formatPrice(cents / 100);

export const REFUND_STATUS_LABELS: Record<ContractRefundStatus, string> = {
  waiting_payment: "En attente de l'encaissement du prélèvement",
  waiting_funds: 'En attente de fonds chez le vendeur (virements suspendus)',
  creating: 'En cours de création',
  pending: 'Envoyé à la banque du client',
  succeeded: 'Effectué',
  failed: 'En échec',
  canceled: 'Annulé (prélèvement échoué, rien à rembourser)',
};

export const COMMISSION_STATUS_LABELS: Record<ContractRefundCommissionStatus, string> = {
  not_requested: 'Conservée par Affinicar',
  waiting: 'Sera rendue au vendeur une fois le remboursement effectif',
  refunded: 'Rendue au vendeur',
  manual_required: 'À rendre manuellement (déjà facturée)',
  failed: "Non rendue (erreur, l'équipe SAV est prévenue)",
};
